import React from 'react';
import Avatar from '@mui/material/Avatar';

export default function ({
    name,
    src = null,
    size = 40,
    color = null,
    maxInitials = null,
    sx = {}
}) {
    const words = (name || '').split(/\s+/g).filter(Boolean);
    // Unlimited by default, so AppHeader keeps the initials it has always
    // shown; the chat rows opt into the design's two-character avatar.
    let letters;
    if (maxInitials && words.length === 1) {
        // A one-word name yields a single initial, so fill the avatar out with
        // the start of the word itself: "Cher" -> "CH".
        letters = words[0].slice(0, maxInitials).split('');
    } else {
        letters = words.map((word) => word[0]);
        if (maxInitials) {
            letters = letters.slice(0, maxInitials);
        }
    }
    const initials = letters.join('').toUpperCase();
    return (
        <Avatar
            alt={name}
            src={src}
            sx={[
                (theme) => ({
                    width: size,
                    height: size,
                    fontSize: size * 0.4,
                    fontWeight: 500,
                    lineHeight: 1,
                    // Any sx colour value works, palette paths included; grey by
                    // default so callers that don't set it are unaffected.
                    backgroundColor: color || theme.palette.grey[400],
                    color: theme.palette.common.white
                }),
                ...(Array.isArray(sx) ? sx : [sx])
            ]}>
            {initials}
        </Avatar>
    );
}
